import { getCurrentLocale } from "./getCurrentLocale";

export function getOtherLocale() {
  const locale = getCurrentLocale()
  if (locale === "en") return "pl"
  if (locale === "pl") return "en"
  return null;
}
